import React from "react";
import {
    Accordion,
    AccordionContent,
    AccordionItem,
    AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
    {
        q: "¿Quién puede asociarse a ASATTA?",
        a: "Cualquier alojamiento turístico legalmente constituido en Tarifa: hoteles, campings, hostales y apartamentos turísticos. Están representados todos los tamaños y modelos.",
    },
    {
        q: "¿Cuánto cuesta ser socio?",
        a: "La cuota es de 15 € al mes por alojamiento asociado. Únete sin ataduras, pero con vocación: pedimos a cada asociado un compromiso mínimo de un año para construir juntos una asociación fuerte.",
    },
    {
        q: "¿Qué obtengo por mi cuota?",
        a: "Representación del sector, visibilidad en nuestros canales, acceso a proyectos e iniciativas conjuntas, red de contactos local, información y apoyo continuo.",
    },
    {
        q: "¿Cómo doy de alta mi alojamiento?",
        a: "Haz clic en el botón 'Hazte socio' de esta web y completa el registro en nuestra app. En pocos pasos formarás parte de ASATTA.",
    },
    {
        q: "¿Existe permanencia?",
        a: "Pedimos a cada asociado un compromiso mínimo de un año para construir juntos una asociación fuerte. Pasado ese periodo puedes darte de baja cuando lo desees desde tu área de socio.",
    },
    {
        q: "¿ASATTA participa en proyectos con la administración local?",
        a: "Sí. Colaboramos con el Ayuntamiento y otras entidades del sector para promover el destino y mejorar la calidad de la oferta turística.",
    },
];

export default function FAQ() {
    return (
        <section
            id="faq"
            data-testid="faq-section"
            className="bg-white"
        >
            <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-20 sm:py-28">
                <div className="mb-14">
                    <div className="text-xs uppercase tracking-widest text-[#082050]/70 mb-4">
                        Preguntas frecuentes
                    </div>
                    <h2 className="text-3xl sm:text-4xl font-semibold text-[#082050] tracking-tight">
                        Resolvemos tus dudas antes de asociarte.
                    </h2>
                </div>

                <Accordion type="single" collapsible className="w-full">
                    {faqs.map((f, i) => (
                        <AccordionItem
                            key={i}
                            value={`faq-${i}`}
                            data-testid={`faq-item-${i}`}
                            className="border-b border-[#E2E4E9]"
                        >
                            <AccordionTrigger className="text-left text-base sm:text-lg font-medium text-[#082050] py-6 hover:no-underline">
                                {f.q}
                            </AccordionTrigger>
                            <AccordionContent className="text-[#4A5568] text-base leading-relaxed pb-6">
                                {f.a}
                            </AccordionContent>
                        </AccordionItem>
                    ))}
                </Accordion>
            </div>
        </section>
    );
}
